import type { FC } from 'react';
import styled from 'styled-components';
import { Branding } from '../grid/Branding';
import { config } from '../config';

const FooterDiv = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-grow: 0;
  padding: 20px;
  box-sizing: border-box;
`;

const FlexItem = styled.div`
  flex-grow: 1;
  flex-basis: 0;
`;

const TermsItem = styled(FlexItem)`
  text-align: right;
`;

const TermsLink = styled.a`
  color: #000000;
`;

const Footer: FC = () => (
  <FooterDiv>
    {config.branding.enabled && (
      <FlexItem>
        <Branding />
      </FlexItem>
    )}
    <TermsItem>
      <TermsLink href="/terms">Terms</TermsLink>
    </TermsItem>
  </FooterDiv>
);

export { Footer };
